<template>
  <div class="container-pricing">
    <section class="img-bg">
      <div class="box-video">
        <video src="/static/video/pricing/Business Pricing-Banner.mov"
            webkit-playsinline='true'
            playsinline='true'
            x5-video-player-type='h5'
            x5-video-player-fullscreen='true'
            x-webkit-airplay='true'
            muted
            loop
            autoplay
            id="20210413"
            ></video>
      </div>
    </section>
    <section class="part1">
      <div class="box-word">
        <p class="title wow slideInLeft" data-wow-delay="0.7s" data-wow-duration="2s">
          Business Pricing
        </p>
        <p class="text wow slideInLeft" data-wow-delay="1s" data-wow-duration="2s">
          Low cost, but highly flexible plans that <br>
          serve you better.
        </p>
      </div>
    </section>
    <section class="new-part2">
      <ul class="list-cont">
        <li>
          <img class="ic01" src="/static/svg/Pricing/Pay-as-you-go  .svg">
          <h3 class="title">Pay-as-you-go</h3>
          <p class="text">No more big contracts. You simply pay for data usage that you need.</p>
        </li>
        <li>
          <img class="ic01" src="/static/svg/Pricing/Committed-use discounts.svg">
          <h3 class="title">Committed-use discounts</h3>
          <p class="text">Contact us on deeper discounts in exchange for your commitment to usage needs.</p>
        </li>
        <li>
          <img class="ic01" src="/static/svg/Pricing/Quantity discounts  .svg">
          <h3 class="title">Quantity discounts</h3>
          <p class="text">Discounts are automatically applied as your usage grows.</p>
        </li>
      </ul>
    </section>
    <section class="part2">
      <div class="box-word">
        <h3 class="h-title">IoT Platform</h3>
      </div>
      <div class="box-cont">
        <div class="box-image-text">
          <v-item01 v-for="(val,index) in dataObj" :key="index" :itemData='val' :show="show" @changeShowStatus="changeShowStatus"></v-item01>
        </div>
      </div>
    </section>
    <section class="part3">
      <div class="box-word">
        <h3 class="h-title">Cloud Video Recording & Streaming</h3>
      </div>
      <div class="box-cont">
        <div class="box-image-text">
          <v-item02 v-for="(val,index) in dataObj2" :key="index" :itemData='val' :show="show" @changeShowStatus="changeShowStatus"></v-item02>
        </div>
      </div>
    </section>

    <section class="part2">
      <div class="box-word">
        <h3 class="h-title">Web & Mobile Apps</h3>
      </div>
      <div class="box-cont">
        <div class="box-image-text">
          <v-item03 :itemData='dataObj3' :show="show" @changeShowStatus="changeShowStatus"></v-item03>
        </div>
      </div>
    </section>
    <section class="part3">
      <div class="box-word">
        <h3 class="h-title">Analytics & Growth Tools</h3>
      </div>
      <div class="box-cont">
        <div class="box-image-text">
          <v-item04 :itemData='dataObj4' :show="show" @changeShowStatus="changeShowStatus"></v-item04>
        </div>
      </div>
    </section>
    <section class="part2">
      <div class="box-word">
        <h3 class="h-title">Value-Added Service</h3>
      </div>
      <div class="box-cont">
        <div class="box-image-text">
          <v-item03 :itemData='dataObj5' :show="show" @changeShowStatus="changeShowStatus"></v-item03>
        </div>
      </div>
    </section>
    <v-whymeshare></v-whymeshare>
    <v-connactUs :show="show" @changeShowStatus="changeShowStatus"></v-connactUs>
  </div>
</template>

<script>
import item01 from './modules/item01.vue'
import item02 from './modules/item02.vue'
import item03 from './modules/item03.vue'
import item04 from './modules/item04.vue'
import connactUs from '../../modules/Popover/connactUS'
import whymeShareCommon from '../common/why-meshare.vue'
import {WOW} from 'wowjs'
import Swiper from 'swiper'
export default {
  name: 'pricing',
  components:{
    'v-item01': item01,
    'v-item02': item02,
    'v-item03': item03,
    'v-item04': item04,
    'v-whymeshare': whymeShareCommon,
    'v-connactUs': connactUs
  },
  data () {
    return {
      active: 0,
      show: false,
      dataObj:[
        {
          iconUrl: '/static/svg/Pricing/Device Connection.svg',
          title: 'Device Connection',
          list: [
            {title: '', text: 'Connect and maintain communications between devices and the platform. ', price: '$0.495/million',},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
        {
          iconUrl: '/static/svg/Pricing/API Call.svg',
          title: 'API Call',
          list: [
            {title: '', text: 'Enable API calls, billed based on usage (per call).  ', price: '$9.95/million'},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
        {
          iconUrl: '/static/svg/Pricing/Video Alert.svg',
          title: 'Video Alert',
          list: [
            {title:'<span class="crl"></span>Upload', text: 'Enable devices to upload video-based alerts to the platform. ', price:'Upload: $99.95/million'},
            {title:'<span class="crl"></span>App', text: 'Push video-based alerts from the platform to the front-end apps. ', price:'App: $149.95/million'},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
      ],
      dataObj2:[
        {
          iconUrl: '/static/svg/Pricing/Video Streaming.svg',
          title: 'Video Streaming',
          text: 'Low-latency, HD video streams with audio, instant load times, and more. ',
          price: '$21.15/TB',
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
        {
          iconUrl: '/static/svg/Pricing/Video Computing.svg',
          title: 'Video Computing',
          text: 'Data computing and analyzing before transferring to storage room. ',
          price: '$7.95/TB',
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
        {
          iconUrl: '/static/svg/Pricing/Cloud Storage.svg',
          title: 'Cloud Storage',
          text: 'Enable long-term, cloud-based data storage solutions. ',
          price: '$6.95/TB',
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
      ],
      dataObj3:[
        {
          iconUrl: '/static/svg/Pricing/On-Demand Live View.svg',
          title: 'On-Demand Live View',
          list: [
            {title:'<span class="crl"></span>App', text: 'Enable low-latency, HD video live viewing through mobile apps on demand. '},
            {title:'<span class="crl"></span>Web', text: 'Enable low-latency, HD video live viewing through web apps on demand.'},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
        {
          iconUrl: '/static/svg/Pricing/Low-Code App.svg',
          title: 'Low-Code App',
          list: [
            {title:'', text: 'Develop custom front-end apps using our low-code implementation to meet your specific solutions and needs. '},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
      ],
      dataObj4:[
        {
          iconUrl: '/static/svg/Pricing/MROMs .svg',
          title: 'MROMs',
          list: [
            {title:'', text: 'Utilize our platform management software to manage, customize, and grow your business with data analytics, marketing tools, and more. '},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
        {
          iconUrl: '/static/svg/Pricing/SaaS Support .svg',
          title: 'SaaS Support',
          list: [
            {title:'', text: 'Expert consultation and services to help you manage, analyze and scale your SaaS revenue.'},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
      ],
      dataObj5:[
        {
          iconUrl: '/static/svg/Pricing/Customer Care.svg',
          title: 'Customer Care',
          list: [
            {title:'', text: 'Online Support (Live Chat, Email, Social) Phone Support'},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
        {
          iconUrl: '/static/svg/Pricing/Marketing.svg',
          title: 'Marketing',
          list: [
            {title:'', text: 'Brand Consultation Graphic Design & Videography'},
          ],
          button: {
            name: 'MORE DETAILS',
            link: '',
          },
        },
      ]
    }
  },
  mounted(){
    new WOW({live:false}).init();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy(){
    window.removeEventListener("scroll", this.handleScroll);
  },
  destroyed(){

  },
  methods:{
    handleScroll(){
      if (window.pageYOffset > 100) {
        // console.log('home: ' + window.pageYOffset)
      }
    },
    clickHandle(n){
      this.active = n;
    },
    changeShowStatus(v){
      this.show = v;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.container-pricing{
  .lg-show{
    @media screen and (max-width:$media-max-width){
      display: none;
    }
  }
  .sm-show{
    display: none;
    @media screen and (max-width:$media-max-width){
      display: block;
    }
  }
  @media screen and (max-width:$media-max-width){
    // display: none;
  }
  .img-bg{
    // background-image: url(/static/images/pricing/1001.jpg);
    background-image: url(/static/video/pricing/Business-Pricing-Ban.jpg);
    background-repeat: no-repeat;
    background-position: center 0px;
    background-size: cover;
    height: 784px;
    width: 100%;
    min-width: $min-body-width;
    position: fixed;
    top: 0px;
    left: 0;
    z-index: -1;
    @media screen and (max-width: 1400px){
      height: calc(300px + 34.57vw);
    }
    @media screen and (max-width:$media-max-width){
      height: 100vw;
      min-height: 64vw;
      max-height: 600px;
      min-width: unset;
      background-position-y: 45px;
    }
    .box-video{
      width: 100%;
      height: 100%;
      video{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
  .part1{
    z-index: 1;
    background: transparent;
    height: 784px;
    margin-top: -55px;
    @media screen and (max-width: 1400px){
      height: calc(300px + 34.57vw);
    }
    @media screen and (max-width:$min-body-width){
      //   height: 465px;
    }
    @media screen and (max-width:$media-max-width){
      height: 100vw;
      min-height: 64vw;
      max-height: 600px;
      margin-top: 0px;
    }
    .box-word{
      color: #ffffff;
      padding-top: 355px;
      width: 96%;
      max-width: 1280px;
      margin-left: auto;
      margin-right: auto;
      @media screen and (max-width: 1400px){
        padding-top: 25.36vw;
      }
      @media screen and (max-width:$media-max-width){
        width: 90%;
        padding-top: 26%;
      }
      @media screen and (max-width:500px){
        padding-top: 115px;
      }
      .word{
        font-size: 20px;
        font-family: 'GothamBold';
        margin-bottom: 5px;
        @media screen and (max-width:$media-max-width){
          margin-bottom: 5px;
          font-size: 17px;
        }
      }
      .title{
        font-size: 55px;
        font-family: 'GothamBook';
        margin-bottom: 25px;
        @media screen and (max-width:$media-max-width){
          font-size: 30px;
        }
        @media screen and (max-width:500px){
          font-size: 20px;
        }
      }
      .text5{
        font-size: 14px;
        font-family: 'GothamBook';
        margin-top: -5px;
        margin-bottom: 25px;
        @media screen and (max-width:500px){
          font-size: 12px;
          font-size: 2.4vw;
          margin-bottom: 15px;
        }
        .line4{
          display: inline;
          background: #ba0c2f;
          padding-right: 1px;
          margin-right: 5px;
          margin-left: 3px;
        }
      }
      .text{
        font-size: 24px;
        line-height: 27px;
        font-family: 'GothamLight';
        margin-bottom: 45px;
        width: 66%;
        max-width: 700px;
        @media screen and (max-width:$media-max-width){
          font-size: 14px;
          line-height: 20px;
          width: 90%;
          margin-bottom: 35px;
        }
      }
      .btn{
        display: -webkit-flex;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-family: 'GothamLight';
        border: 1px solid #ba0c2f;
        background: #ba0c2f;
        color: #ffffff;
        box-sizing: border-box;
        text-decoration: none;
        height: 38px;
        width: 180px;
        transition: all .7s;
        border-radius: 20px;
        text-transform: uppercase;
        cursor: pointer;
        @media screen and (max-width:$media-max-width){
          height: 34px;
        }
        &:hover{
          background: transparent;
          color: #ffffff;
          border-color: #ffffff;
        }
      }
    }
  }
  .new-part2{
    background-color: #f7f7f7;
    padding: 80px 0;
    @media screen and (max-width:1208px){

    }
    @media screen and (max-width:$media-max-width){
      padding: 20px 0;
    }
    .list-cont{
      width: 90%;
      max-width: 1300px;
      margin: 0 auto;
      display: -webkit-flex;
      display: flex;
      flex-direction: row;
      justify-content: center;
      @media screen and (max-width:$media-max-width){
        flex-direction: column;
      }
      li{
        width: 33%;
        text-align: center;
        box-sizing: border-box;
        @media screen and (max-width:$media-max-width){
          width: 100%;
          padding: 10px 0;
        }
      }
      .ic01{
        margin-bottom: 10px;
        width: 13.5%;
        max-width: 59px;
      }
      .title{
        color: #2b2b2b;
        font-size: 22px;
        font-family: 'GothamLight';
        margin-bottom: 20px;
        @media screen and (max-width:$media-max-width){
          font-size: calc(8px + 2vw);
        }
      }
      .text{
        color: #515151;
        font-size: 16px;
        font-family: 'GothamLight';
        line-height: 20px;
        padding: 0 15%;
        @media screen and (max-width:$media-max-width){
          font-size: calc(8px + 1.1vw);
          line-height: calc(10px + 1.6vw);
          padding: 0 5%;
        }
      }
    }
  }
  .part2{
    background: #ffffff;
    padding: 60px 0 30px;
    @media screen and (max-width:$media-max-width){
      padding: 20px 0 0;
    }
    .box-word{
      width: 90%;
      max-width: $max-content-width;
      margin: 0 auto;
      text-align: center;
      .h-title{
        font-size: 24px;
        font-family: 'GothamLight';
        color: #b81233;
        line-height: 30px;
        text-transform: uppercase;
        @media screen and (max-width:$media-max-width){
          font-size: 14px;
          font-size: calc(10px + 2vw);
        }
      }
      .title{
        font-size: 20px;
        font-family: 'GothamLight';
        color: #b81233;
        line-height: 30px;
        margin-bottom: 15px;
        @media screen and (max-width:$media-max-width){
          font-size: 15px;
          line-height: 20px;
        }
      }
      .text{
        font-size: 16px;
        font-family: 'GothamLight';
        color: #000000;
        line-height: 25px;
        @media screen and (max-width:$media-max-width){
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
    .box-cont{
      width: 90%;
      max-width: 1280px;
      margin: 20px auto 0;
      @media screen and (max-width:$media-max-width){
        width: 100%;
        margin: 0px auto 0;
      }
      .box-label{
        position: relative;
        .list-label{
          display: -webkit-flex;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          max-width: 1000px;
          margin: 0 auto;
          li{
            padding: 10px 20px;
            font-size: 17px;
            font-family: 'GothamLight';
            transition: all .5s;
            font-weight: bold;
            cursor: pointer;
            @media screen and (max-width:$media-max-width){
              font-size: 12px;
              padding: 10px 5px;
            }
            &:hover{
              //   color: $c-main;
            }
            &.active{
              color: $c-main;
            }
          }
        }
        .line{
          display: block;
          width: 100%;
          height: 2px;
          background: rgba(0,0,0,.2);
          margin-top: 10px;
        }
      }
      .box-image-text{
        position: relative;
        .box-item{
          padding: 30px 0 0 0;
          @media screen and (max-width:$media-max-width){
            padding: 0px 0 0 0;
            width: 90%;
            margin: 0 auto;
          }
        }
        .word1{
          font-size: 24px;
          font-family: 'GothamLight';
          color: $c-main;
          text-align: center;
          font-weight: bold;
          @media screen and (max-width:$media-max-width){
            font-size: 14px;
          }
        }
      }
    }
  }

  .part3{
    background: #f7f7f7;
    padding: 60px 0 30px;
    @media screen and (max-width:$media-max-width){
      padding: 20px 0 0;
    }
    .box-word{
      width: 90%;
      max-width: $max-content-width;
      margin: 0 auto;
      text-align: center;
      .h-title{
        font-size: 24px;
        font-family: 'GothamLight';
        color: #b81233;
        line-height: 30px;
        text-transform: uppercase;
        @media screen and (max-width:$media-max-width){
          font-size: 14px;
        }
      }
      .title{
        font-size: 20px;
        font-family: 'GothamLight';
        color: #b81233;
        line-height: 30px;
        margin-bottom: 15px;
        @media screen and (max-width:$media-max-width){
          font-size: 15px;
          line-height: 20px;
        }
      }
      .text{
        font-size: 16px;
        font-family: 'GothamLight';
        color: #000000;
        line-height: 25px;
        @media screen and (max-width:$media-max-width){
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
    .box-cont{
      width: 90%;
      max-width: 1280px;
      margin: 20px auto 0;
      @media screen and (max-width:$media-max-width){
        width: 100%;
        margin: 0px auto 0;
      }
      .box-label{
        position: relative;
        .list-label{
          display: -webkit-flex;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          max-width: 1000px;
          margin: 0 auto;
          li{
            padding: 10px 20px;
            font-size: 17px;
            font-family: 'GothamLight';
            transition: all .5s;
            font-weight: bold;
            cursor: pointer;
            @media screen and (max-width:$media-max-width){
              font-size: 12px;
              padding: 10px 5px;
            }
            &:hover{
              //   color: $c-main;
            }
            &.active{
              color: $c-main;
            }
          }
        }
        .line{
          display: block;
          width: 100%;
          height: 2px;
          background: rgba(0,0,0,.2);
          margin-top: 10px;
        }
      }
      .box-image-text{
        position: relative;
        .box-item{
          padding: 30px 0 0 0;
          @media screen and (max-width:$media-max-width){
            padding: 0px 0 0 0;
            width: 90%;
            margin: 0 auto;
          }
        }
        .word1{
          font-size: 24px;
          font-family: 'GothamLight';
          color: $c-main;
          text-align: center;
          font-weight: bold;
          @media screen and (max-width:$media-max-width){
            font-size: 14px;
          }
        }
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/pricing/index.vue